import { StarIcon } from '@heroicons/react/24/outline'

export default function TeamsResultHeader({ teamsResult }) {
  if (!teamsResult) return null

  return (
    <>
      {/* MOBILE */}
      <div className="grid grid-cols-1 bg-sec-grey-4 lg:hidden">
        <div className="grid grid-cols-1 bg-sec-grey-4">
          {Array.from({ length: 2 }).map((_, idx) => {
            const logo = teamsResult[`Team${idx + 1}Logo`]
            return (
              <>
                <div
                  className="relative flex items-center space-x-3 px-6 py-5 flex-1"
                  key={idx + 1}
                >
                  <div className="flex-shrink-0">
                    {logo ? (
                      <img
                        className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                        src={logo}
                        alt={`Team ${idx + 1}`}
                      />
                    ) : (
                      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white">
                        <StarIcon className="h-8 w-8" />
                      </div>
                    )}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="focus:outline-none">
                      <span className="absolute inset-0" aria-hidden="true" />
                      <p className="text-[16px] font-bold text-blue truncate">
                        {teamsResult[`team${idx + 1}`]}
                      </p>
                    </div>
                  </div>
                </div>
                {idx === 0 && (
                  <div className="flex justify-center items-center flex-1 col-span-2 bg-sec-grey-3 py-2">
                    <p className="text-[18px] font-bold text-blue">
                      {teamsResult['Team1Score']} - {teamsResult['Team2Score']}
                    </p>
                  </div>
                )}
              </>
            )
          })}
        </div>
      </div>

      {/* DESKTOP */}
      <div className="hidden lg:grid grid-cols-1 bg-sec-grey-4">
        <div className="relative flex items-center space-x-3 px-6 py-5 flex-1">
          {Array.from({ length: 2 }).map((_, idx) => {
            const logo = teamsResult[`Team${idx + 1}Logo`]
            return (
              <>
                <div
                  className="flex items-center space-x-3 flex-1"
                  key={idx + 1}
                >
                  <div className="flex-shrink-0">
                    {logo ? (
                      <img
                        className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                        src={logo}
                        alt={`Team ${idx + 1}`}
                      />
                    ) : (
                      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white">
                        <StarIcon className="h-8 w-8" />
                      </div>
                    )}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="focus:outline-none">
                      <span className="absolute inset-0" aria-hidden="true" />
                      <p className="text-[16px] font-bold text-blue truncate">
                        {teamsResult[`team${idx + 1}`]}
                      </p>
                    </div>
                  </div>
                </div>
                {idx === 0 && (
                  <div className="flex justify-center items-center flex-1">
                    <p className="text-2xl font-bold text-blue">
                      {teamsResult['Team1Score']} - {teamsResult['Team2Score']}
                    </p>
                  </div>
                )}
              </>
            )
          })}
        </div>
      </div>
    </>
  )
}
